export class AxSlide {
    private El: Element;
    private Sliders: AxSliderInternal[] = [];

    public Init(initData: Element) {
        this.El = initData;

        this.El.Slider.each((i, e) => {
            this.Sliders.push(new AxSliderInternal($(e).find(this.El.HolderSelector), this.El.ElemSelector));
        });
    }
}

class AxSliderInternal {

    private Holder: JQuery<HTMLElement>;
    private SliderElem: JQuery<HTMLElement>;

    private Touchstartx: number;
    private Touchmovex: number;
    private Movex: number;
    private SliderWidth: number;
    private MaxSize: number;

    constructor(holder: JQuery<HTMLElement>, elemSelector: string) {
        this.Touchstartx = 0;
        this.Touchmovex = 0;
        this.Movex = 0;

        this.Holder = holder;
        this.SliderWidth = holder.width();
        this.SliderElem = this.Holder.find(elemSelector);


        this.BindUIEvents();
    }

    private BindUIEvents() {
        this.Holder.on("touchstart", (event) => {
            this.Start(event);
        });

        this.Holder.on("touchmove", (event) => {
            this.Move(event);
        });

        this.Holder.on("touchend", (event) => {
            this.End(event);
        });

    }

    private GetMaxSize() {
        let maxSize: number = 0;

        this.SliderElem.each((i, x) => {
            maxSize += $(x).outerWidth();
        });
        return maxSize - this.SliderWidth;
    }

    private Start(event) {
        this.Touchstartx = event.originalEvent.touches[0].pageX;
        this.MaxSize = this.GetMaxSize();
        $('.animate').removeClass('animate');
    }

    private Move(event) {
        this.Touchmovex = event.originalEvent.touches[0].pageX;
        let currTrans = parseInt((this.Holder.css("transform").split(",")[4] ?? "0").trim()) * -1;
        this.Movex = currTrans + this.Touchstartx - this.Touchmovex;
        if (this.Movex < this.MaxSize + 20) {
            this.Holder.css('transform', 'translateX(-' + this.Movex + 'px)');
        }
    }

    private End(event) {
        if (this.Movex > this.MaxSize) {
            this.Holder.css('transform', 'translateX(-' + this.MaxSize + 'px)');
        }
    }
}

class Element {
    Slider: JQuery<HTMLElement>;

    HolderSelector: string;
    ElemSelector: string;
}